/* eslint-disable no-useless-escape */
import * as yup from 'yup';
import { AnySchema } from 'yup';
import Lazy from 'yup/lib/Lazy';
import Reference from 'yup/lib/Reference';

import { IErrorObject } from '../../../utils/validator';

export enum COUPON_FIELD_KEYS {
  TITLE = 'title',
  FILE_NAME = 'fileName',
}

export interface IErrorsCoupon {
  title?: IErrorObject;
  fileName?: IErrorObject;
}

export type ICouponFields = keyof IErrorsCoupon;

const CouponFormObj: { [key in ICouponFields]: AnySchema<unknown, unknown, unknown> | Reference<unknown> | Lazy<never, unknown> } = {
  title: yup.string().nullable().required('Title is required').trim(),
  fileName: yup.string().nullable().required('Please upload CSV file'),
};

export default CouponFormObj;
